export default __webpack_public_path__ + "f6e99c15a30b86156bd2184a2979be4b.glb";